/**
 * Chart.js shared constants and utilities.
 */

export const CHART_COLORS = {
  primary: "#3273dc",
  success: "#23d160",
  tension: "#e53e3e",
  tensionWeak: "rgba(229, 62, 62, 0.6)",
  intersection: "#f39c12",
  palette: [
    "#4a4a4a", "#3273dc", "#209cee", "#23d160", "#ffdd57",
    "#ff3860", "#770077", "#00d1b2", "#f14668", "#7957d5", "#363636"
  ]
}

/**
 * Get color from palette by index (cycles).
 * @param {number} i - index
 * @param {string[]} [palette] - optional palette override
 * @returns {string}
 */
export function colorForIndex(i, palette = CHART_COLORS.palette) {
  return palette[i % palette.length]
}

/**
 * Tension level by steps (diff / coefficient per scale): 0–2 none, 3–6 weak, 7+ strong.
 * @param {number} steps - diff / coefficient for the scale
 * @returns {'none' | 'weak' | 'strong'}
 */
export function tensionBySteps(steps) {
  if (steps <= 2) return "none"
  if (steps <= 6) return "weak"
  return "strong"
}

export const TENSION_OPACITY_BY_LEVEL = { none: 0, weak: 0.2, strong: 0.5 }
